import { View } from 'components/View'
import PropTypes from 'prop-types'
import React from 'react'
import getStyleComponentUtil from 'modules/component/utils/get-style'
import ListRowImage from './ListRow.Image'
import ListRowMeta from './ListRow.Meta'
import ListRowText from './ListRow.Text'

const PADDING_SIZE = {
  SMALL: '0.66em 0.44em'
}

class ListRow extends React.Component {
  render () {
    return (
      <View
        onClick={this.props.onClick}
        style={getStyleComponentUtil({
          width: this.props.isFullWidth ? '100%' : null,
          cursor: this.props.onClick ? 'pointer' : null,
          padding: this.props.padding || '0.833em',
          boxSizing: 'border-box',
          height: '100%',
          borderBottom: this.props.isBorderless
            ? null
            : '0.055em solid #e6e6e6',
          transition: 'all 0.125s ease-out',
          alignItems: this.props.align,
          justifyContent: this.props.justify,
          flexDirection: View.DIRECTION.ROW
        }, this.props.style)}
      >
        {this.props.children}
      </View>
    )
  }
}

ListRow.ALIGN = View.ALIGN
ListRow.Image = ListRowImage
ListRow.JUSTIFY = View.JUSTIFY
ListRow.Meta = ListRowMeta
ListRow.PADDING = PADDING_SIZE
ListRow.Text = ListRowText
ListRow.defaultProps = {
  alignItems: View.ALIGN.CENTER
}
ListRow.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
  padding: PropTypes.oneOf(
    Object.values(ListRow.PADDING)
  ),
  align: PropTypes.oneOf(Object.values(View.ALIGN)),
  justify: PropTypes.oneOf(Object.values(View.JUSTIFY)),
  isBorderless: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  hasHover: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object.isRequired
}

ListRow.defaultProps = {
  style: {}
}

export default ListRow
